import supabase from './supabase';

/**
 * Update EXAMPLE_QUESTION element in syllabus_skill.elements_json
 *
 * @deprecated Use updateExampleQuestionElementBySkillId instead (uses skill.id instead of element_id)
 * @param elementId - The ID of the element to update
 * @param newQuestionsData - The new questions object data
 * @returns Promise that resolves when update is complete
 */
export async function updateExampleQuestionElement(
  elementId: string,
  newQuestionsData: any
): Promise<void> {
  try {
    console.log('🔍 Searching for element:', elementId);

    // First, find which syllabus_skill contains this element
    const { data: skills, error: fetchError } = await supabase
      .from('syllabus_skill')
      .select('element_id, elements_json')
      .not('elements_json', 'is', null);

    if (fetchError) {
      throw new Error(`Failed to fetch syllabus_skill: ${fetchError.message}`);
    }

    if (!skills || skills.length === 0) {
      throw new Error('No syllabus_skill records found');
    }

    console.log('📊 Found skills:', skills.length);

    // Search for the element in elements_json arrays
    let targetSkill: any = null;
    for (const skill of skills) {
      if (Array.isArray(skill.elements_json)) {
        const foundElement = skill.elements_json.find(
          (el: any) => el.id === elementId
        );
        if (foundElement) {
          console.log('✅ Found element:', foundElement);
          targetSkill = skill;
          break;
        }
      }
    }

    if (!targetSkill) {
      throw new Error(`element with id ${elementId} not found in any syllabus_skill`);
    }

    // Update the elements_json array
    const updatedElementsJson = targetSkill.elements_json.map((el: any) => {
      if (el.id === elementId) {
        return {
          ...el,
          questions: newQuestionsData
        };
      }
      return el;
    });

    // Write back to database using element_id
    const { error: updateError } = await supabase
      .from('syllabus_skill')
      .update({ elements_json: updatedElementsJson })
      .eq('element_id', targetSkill.element_id);

    if (updateError) {
      throw new Error(`Failed to update syllabus_skill: ${updateError.message}`);
    }

    console.log('✅ EXAMPLE_QUESTION updated successfully:', elementId);
  } catch (error) {
    console.error('❌ Failed to update EXAMPLE_QUESTION:', error);
    throw error;
  }
}

/**
 * Update EXAMPLE_QUESTION element in syllabus_skill.elements_json using skill's primary key
 * This is the preferred method for math2-preview as it avoids database searches
 *
 * @param element - The element object that contains _math2_skill_info
 * @param newQuestionsData - The new questions object data
 * @param skillId - The skill's primary key (id field, not element_id)
 * @param currentElementsJson - The current elements_json array from the skill
 * @returns Promise that resolves when update is complete
 */
export async function updateExampleQuestionElementBySkillId(
  element: any,
  newQuestionsData: any,
  skillId: number,
  currentElementsJson: any[]
): Promise<void> {
  try {
    const elementId = element.id;

    console.log('🔍 Updating element:', elementId, 'in skill ID:', skillId);

    // Update the elements_json array
    const updatedElementsJson = currentElementsJson.map((el: any) => {
      if (el.id === elementId) {
        return {
          ...el,
          questions: newQuestionsData
        };
      }
      return el;
    });

    // Write back to database using the primary key (id)
    const { error: updateError } = await supabase
      .from('syllabus_skill')
      .update({ elements_json: updatedElementsJson })
      .eq('id', skillId);

    if (updateError) {
      throw new Error(`Failed to update syllabus_skill: ${updateError.message}`);
    }

    console.log('✅ EXAMPLE_QUESTION updated successfully:', elementId);
  } catch (error) {
    console.error('❌ Failed to update EXAMPLE_QUESTION:', error);
    throw error;
  }
}
